import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Color, Pagination } from '../models';
import { BaseApiService } from './baseApiService';
import { StorageKey } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class ColorService extends BaseApiService<Color> {
  get cacheKey(): StorageKey {
    return StorageKey.colorServiceCache;
  }

  getUrl(operation: string, params, id: string = null): string {
    switch (operation) {
      case 'list':
        let regionId = params.regionId;
        if (regionId == null) {
          regionId = 'Brasil';
        }
        return `${environment.apiUrl}/regions/${encodeURIComponent(regionId)}/colors`;
      default:
        let url = `${environment.apiUrl}/colors`;
        if (id != null) {
          url = url + '/' + encodeURIComponent(id);
        }
        return url;
    }
  }

  list(params: {[params: string]: string}): Promise<Pagination<Color>> {
    return super.list(this.removeContractId(params));
  }

  protected unparse(obj) {
    return Color.unparse(obj);
  }

  protected parse(obj) {
    return Color.parse(obj);
  }

}
